<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane name="1" label="快跑配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importBaseCfg" :export-method="exportBaseCfg" />
                <clear-cache-apply />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[3]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="复活配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.revive">
                    <el-option v-for="item in list[4]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="进度奖励配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.progressReward">
                    <el-option v-for="item in list[5]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="地图配置" align="center">
                <template slot-scope="scope">
                  <div style="width: 100%;height: 100%;min-height: 1rem;white-space: pre-wrap" @click="handleEditMapWeight(scope.row.mapWeight)">
                    <i class="el-icon-edit-outline" style="margin-right: 0.5rem" /><pre>{{ handleMapWeight(scope.row.mapWeight) }}</pre>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel
                  ref="CommonExcelRef2"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importCfg"
                  :export-method="exportCfg"
                />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig(type)">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="60%">
        <el-table size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type == 2">
            <el-table-column label="阶段" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column label="左钱堆数" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.left" placeholder="名左钱堆数" />
              </template>
            </el-table-column>
            <el-table-column label="右钱堆数" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.right" placeholder="右钱堆数" />
              </template>
            </el-table-column>
            <el-table-column label="左选项" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.choice[0]" placeholder="左选项" />
              </template>
            </el-table-column>
            <el-table-column label="右选项" align="center">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.choice[1]" placeholder="右选项" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 3">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="权重" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.v" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template slot-scope="scope">
                <Reward v-model="scope.row.reward" :limit-len="1" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 4">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="价格" align="center">
              <Price />
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type == 5">
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="进度(%)" align="center" width="200">
              <template slot-scope="{row,$index}">
                <el-input v-model="row.progress" placeholder="进度" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template slot-scope="scope">
                <Reward v-model="scope.row.reward" :limit-len="1" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span v-if="type == 3 || type == 4 || type == 5" slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
      <el-dialog title="地图权重" :visible.sync="mapDialog" width="60%">
        <el-table size="mini" :data="mapDialogList" border fit highlight-current-row style="width: 100%;" height="500">
          <el-table-column label="权重" align="center">
            <template slot-scope="{row,$index}">
              <el-input v-model="row.v" style="width: 150px;" placeholder="权重" />
            </template>
          </el-table-column>
          <el-table-column label="速度" align="center" width="150">
            <template slot-scope="{row,$index}">
              <el-input v-model="row.speed" placeholder="速度" />
            </template>
          </el-table-column>
          <el-table-column label="移动距离" align="center" width="150">
            <template slot-scope="{row,$index}">
              <el-input v-model="row.distance" placeholder="速度" />
            </template>
          </el-table-column>
          <el-table-column label="通关费用" align="center">
            <template slot-scope="{row,$index}">
              <el-input v-model="row.need" style="width: 150px;" placeholder="通关费用(等级金币)" />
            </template>
          </el-table-column>
          <el-table-column label="中钱堆范围(min)" align="center">
            <template slot-scope="{row,$index}">
              <el-input v-model="row.median_min" style="width: 150px;" placeholder="中钱堆范围(min)" />
            </template>
          </el-table-column>
          <el-table-column label="中钱堆范围(max)" align="center">
            <template slot-scope="{row,$index}">
              <el-input v-model="row.median_max" style="width: 150px;" placeholder="中钱堆范围(max)" />
            </template>
          </el-table-column>
          <el-table-column label="地图" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.id">
                <el-option v-for="item in list[2]" :value="item.id" :label="item.name" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="{row,$index}">
              <el-button style="margin-left: .5rem;display:block" type="danger" size="mini" @click="deleteMapDialogList($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button type="primary" @click="addMapDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button @click="mapDialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import {
  delRunFotMoneyConf,
  getRunFotMoneyList,
  importRunFotMoneyCfg,
  runFotMoneyBaseConf,
  saveRunFotMoneyBaseConf
} from '@/api/config/run-for-money-cfg'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Price from '@/components/Price'

export default {
  name: 'RunForItMoney',
  components: { Price, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      loading: false,
      dialog: false,
      diaLogList: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 20
      },
      groupsList: [],
      total: 0,
      list: [],
      type: 1,
      typeArr: { 2: '地图配置', 3: '奖励配置', 4: '商品配置', 5: '进度奖励配置' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      goodsDialog: false,
      goodsDialogList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        runFotMoneyBaseConf().then(res => {
          this.baseList = res.data
        })
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    handleSaveBase() {
      saveRunFotMoneyBaseConf({ data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const list = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[3], revive: this.list[4], progressReward: this.list[5] }, true, 'name', 'id')
        for (let i = 0; i < list.length; i++) {
          list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'name', 'id')
        }
        this.baseList = list
        this.handleSaveBase()
        break
      }
    },
    exportBaseCfg() {
      const fileName = '捡钱快跑配置'
      const hearer = []
      const excelData = []
      const name = ['捡钱快跑配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[3], revive: this.list[4], progressReward: this.list[5] }, true, 'id', 'name')
      for (let i = 0; i < list.length; i++) {
        list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'id', 'name')
      }
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, {
        minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, rewardId: '奖励配置', revive: '复活配置', progressReward: '进度奖励配置',
        mapWeight: { name: '地图配置', sub: { v: '权重', speed: '速度', distance: '移动距离', need: '通关费用', median_min: '中钱堆范围(min)', median_max: '中钱堆范围(max)', id: '地图' }}
      })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      getRunFotMoneyList().then(res => {
        this.loading = false
        this.list = res.data.list
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
      })
    },
    handleDel(index, id) {
      if (id == 0) {
        this.list[this.type].splice(index, 1)
      } else {
        delRunFotMoneyConf({ id: id }).then(res => {
          this.list[this.type].splice(index, 1)
        })
      }
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, types: this.type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name == sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      importRunFotMoneyCfg({ data: JSON.stringify(this.list[type]) }).then(res => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      if (type === 2) {
        fileName = '地图配置'
        for (let i = 0; i < dataArr.length; i++) {
          const tAk = this.$refs.CommonExcelRef.makeExcelData(dataArr[i], { stage: '阶段', left: '左钱堆数', right: '右钱堆数', choice: { name: '选项', sub: [] }})
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      } else if (type === 3) {

      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ groupIds: [], mapWeight: [], rewardId: 0, revive: 0, progressReward: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addMapDialogList() {
      this.mapDialogList.push({ v: 10, speed: 15, distance: 6, need: 100, median_min: 3, median_max: 5, id: 0 })
    },
    deleteMapDialogList(index) {
      this.mapDialogList.splice(index, 1)
    },
    handleEditMapWeight(config) {
      this.mapDialog = true
      this.mapDialogList = config
    },
    handleGetMapName(id) {
      for (let i = 0; i < this.list[2].length; i++) {
        if (this.list[2][i].id === id) {
          return this.list[2][i].name
        }
      }
      return ''
    },
    handleMapWeight(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        str += '权重：' + data[i].v + '，通关费用：' + data[i].need + '，地图：' + this.handleGetMapName(data[i].id) + '\n'
      }
      return str
    },
    handleDownLoadJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/makeParkourJson')
    },
    addRewardDialogList() {
      if (this.type == 3) {
        this.diaLogList.push({ v: 0, reward: [] })
      } else if (this.type == 4) {
        this.diaLogList.push({ mtype: 1, bet: 1, sku: '', price: 0, coin: 'money1' })
      } else if (this.type == 5) {
        this.diaLogList.push({ progress: 0, reward: [] })
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

